type TCallback = (e: ErrorEvent | PromiseRejectionEvent) => void

/**
 * A globális error esetén hívathatjuk meg a callbackünket.
 * Leírásért lásd README!
 * @param callback - Errornál megfutó callback.
 */
export default function onError (callback: TCallback): void {
  /**
   * Placeholder függvény, amit el lehet távolítani.
   * @param ev - A hibaesemény.
   */
  function fn (ev: ErrorEvent | PromiseRejectionEvent): void {
    callback(ev)

    window.removeEventListener('error', fn)
  }

  // eslint-disable-next-line no-restricted-syntax -- Jól van.
  window.addEventListener('error', fn)
}
